import styled from "styled-components";

import { ThemeProp } from "styles/theme";
import { datasetsMenuFonts } from "styles/font-sizes";

export const StyledContainer = styled.div`
  width: 100%;
  padding-right: 10px;
  padding-bottom: 5px;
  overflow: hidden;
`;

export const StyledName = styled.div`
  font-size: ${datasetsMenuFonts.databaseName}px;
  background: ${({ theme }: ThemeProp) => theme.emptyBackground};
  padding: 1px 8px; // padding Y axis X axis
  border-radius: 8px;
`;

export const StyledWrapper = styled.div`
  max-width: 100%;
  margin-left: 5px;

  color: ${({ theme }: ThemeProp) => theme.textInLight};

  &&,
  &&&& * {
    transition: color, background ease-in-out 0.2s;
  }

  :hover,
  &.open {
    ${StyledName} {
      color: ${({ theme }: ThemeProp) => theme.emptyBackground};
      background: ${({ theme }: ThemeProp) => theme.textInLight};
    }
  }
`;
